namespace GeniuzPOS.Purchase {
    export interface PoPurInvoicePrintData extends Serenity.ListRequest {
        payment?: string;
        Header?: PoPurInvoiceRow;
        Supdata?: Supplier.CsSupplierRow;
        Details?: PoPurInvoiceDtRow[];
        SysDocNo?: string;
        URLpic?: string;
        Paydesc?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
